import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Login.css'; // Login stillerini kullanabiliriz

function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const handleSubmit = (e) => {
        e.preventDefault();

        if (password.length < 6) {
            toast.error("Şifre en az 6 karakter olmalıdır.");
            return;
        }

        if (!/[a-zA-Z]/.test(password) || !/\d/.test(password)) {
            toast.error("Şifre en az bir harf ve bir rakam içermelidir.");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Şifreler eşleşmiyor.");
            return;
        }

        if (!token) {
            toast.error("Geçersiz işlem.");
            return;
        }

        axios.post('./backend/reset_password_action.php', { token, password })
            .then(res => {
                toast.success(res.data.message);
                setTimeout(() => navigate('/login'), 2000);
            })
            .catch(err => {
                toast.error(err.response?.data?.message || "İşlem başarısız.");
            });
    };

    const calculateStrength = (val) => {
        let score = 0;
        if (!val) return 0;
        if (val.length >= 6) score += 1;
        if (/[A-Z]/.test(val)) score += 1;
        if (/[0-9]/.test(val)) score += 1;
        if (/[^A-Za-z0-9]/.test(val)) score += 1;
        return Math.min(score, 4);
    };

    const handlePasswordChange = (e) => {
        const val = e.target.value;
        setPassword(val);
        setPasswordStrength(calculateStrength(val));
    };

    const getStrengthColor = () => {
        if (passwordStrength <= 2) return '#e74a3b'; // Zayıf - Kırmızı
        if (passwordStrength === 3) return '#f6c23e'; // Orta - Sarı
        return '#1cc88a'; // Güçlü - Yeşil
    };

    const getStrengthLabel = () => {
        if (passwordStrength <= 2) return 'Zayıf';
        if (passwordStrength === 3) return 'Orta';
        return 'Güçlü';
    };

    return (
        <div className="login-container">
            <div className="login-overlay"></div>
            <div className="login-box">
                <div className="login-header">
                    <h2>Yeni Şifre Belirle</h2>
                    <p>Lütfen yeni şifrenizi giriniz.</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Yeni Şifre</label>
                        <div className="password-input-container">
                            <input type={showPassword ? "text" : "password"} value={password} onChange={handlePasswordChange} required />
                            <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? (
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                                ) : (
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                )}
                            </span>
                        </div>
                        {password && (
                            <div className="password-strength-meter">
                                <div 
                                    className="strength-bar" 
                                    style={{ 
                                        width: `${(passwordStrength / 4) * 100}%`, 
                                        backgroundColor: getStrengthColor() 
                                    }} 
                                ></div>
                                <span style={{ fontSize: '0.75rem', color: getStrengthColor(), marginTop: '4px', display: 'block', textAlign: 'right', fontWeight: '600' }}>
                                    {getStrengthLabel()}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Şifre Tekrar</label>
                        <div className="password-input-container">
                            <input type={showConfirmPassword ? "text" : "password"} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required style={confirmPassword && password !== confirmPassword ? { borderColor: '#e74a3b' } : {}} />
                            <span className="password-toggle-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                {showConfirmPassword ? (
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                                ) : (
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                )}
                            </span>
                        </div>
                        {confirmPassword && password !== confirmPassword && (
                            <small style={{ color: '#e74a3b', marginTop: '5px', display: 'block', fontSize: '0.85rem', fontWeight: '600' }}>
                                ⚠️ Şifreler eşleşmiyor
                            </small>
                        )}
                    </div>
                    <button type="submit" className="login-btn">Şifreyi Güncelle</button>
                </form>
            </div>
        </div>
    );
}

export default ResetPassword;